import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import RequestAService from "./sections/RequestAService";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInformation />
      <RequestAService />
      <Footer />
    </div>;
}